import React, { useState, useEffect } from "react";
import { useStore } from "../../store/store";
import { SelectChangeEvent } from "@mui/material";
import { FixesObj } from "../../util/checkForCommonHardware";
import { extractChoiceObj } from "./unitCheck.biz";

function useUnitCheckSelector(
  nonMatches: FixesObj[],
  handleClose: () => void,
  addToCart: (checkCart: boolean, ignoreCheck?: boolean) => void
) {
  const addToQuote = useStore((state) => state.addToQuote);

  const [choices, setChoices] = useState<{ [key: string]: string }>({});

  const [checked, setChecked] = useState(false);

  const [disable, setDisable] = useState(true);

  const handleUpdate = async () => {
    addToQuote(choices);
    handleClose();
    addToCart(true, checked);
  };

  const handleNoUpdate = () => {
    addToCart(false, checked);
  };

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) =>
    setChecked(e.target.checked);

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const { name, value } = event.target;
    setChoices({ ...choices, [name as string]: value as string });

    if (choices[`${name}`] !== value) {
      setDisable(false);
    }
  };

  useEffect(() => {
    if (!nonMatches.length) return;
    setChoices(extractChoiceObj(nonMatches));
  }, [nonMatches]);

  return {
    handleChange,
    handleUpdate,
    handleNoUpdate,
    handleCheck,
    disable,
    checked,
    choices,
  };
}

export default useUnitCheckSelector;
